import React from 'react';
import styled from 'styled-components';
import { Route, Switch } from 'react-router-dom';

import withAuth from '../common/withAuth';
import HraEndContainer from './HraEndContainer';
import HraQuestionContainer from './HraQuestionContainer';
import { connect } from 'react-redux';
import HraExitContainer from './HraExitContainer';
import NotFoundPage from '../../components/home/NotFoundPage';

const Container = styled.div`
  display: flex;
  flex: 1 0;
  flex-direction: column;
  align-items: stretch;
`;

const HraNavigator = (props) => {
  console.log(props);
  return (
    <Container>
      <Switch>
        <Route path="/hra" exact component={HraQuestionContainer} />
        <Route path="/hra/question" component={HraQuestionContainer} />
        <Route path="/hra/exit" component={HraExitContainer} />
        <Route path="/hra/end" component={HraEndContainer} />
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </Container>
  );
};

const mapStateToProps = (state) => {
  return {
    config: state.app.config,
  };
};

export default withAuth(connect(mapStateToProps)(HraNavigator));
